module.exports = __webpack_public_path__ + "static/media/Tuzo-square.800ff25b.png";